<template>
  <div class="auth-page forget-password-page">
    <!-- Logo positioned at top -->
    <div class="logo-container">
      <img src="../assets/images/makeping-logo1.svg" alt="MakePing" class="logo" />
    </div>

    <!-- Main Content Centered -->
    <div class="content-wrapper">
      <!-- Title -->
      <h1 class="page-title">
        Reset <span class="text-orange">Password</span>.
      </h1>
      
      <!-- Form Card -->
      <div class="auth-card">
        <!-- Email Form -->
        <form v-if="!change_password" @submit.prevent="sendMail()">
          <p class="info-text">We will send a password reset link to your register email.</p>
          
          <div class="form-group">
            <label for="email" class="form-label">Enter Your Register Email</label>
            <div class="input-wrapper">
              <img src="../assets/images/icons/mail-icon.svg" class="input-icon" alt="email" />
              <input
                v-model="input.email"
                type="email"
                id="email"
                class="form-control custom-input"
                placeholder="Enter your email"
                maxlength="50"
                autocomplete="email"
                required
              />
            </div>
          </div>

          <!-- Send Link Button -->
          <button type="submit" class="btn btn-auth-primary">
            Sent Link
          </button>
        </form>

        <!-- Password Reset Form -->
        <form v-else @submit.prevent="changePassword()">
          <p class="info-text">Enter your new password below.</p>
          
          <div class="form-group">
            <label for="newpassword" class="form-label">Enter new password</label>
            <div class="input-wrapper">
              <img src="../assets/images/icons/lock-icon.svg" class="input-icon" alt="lock" />
              <input
                v-model="input.password"
                :type="showPassword ? 'text' : 'password'"
                id="newpassword"
                class="form-control custom-input"
                :placeholder="input.password ? '••••••••' : 'Enter new password'"
                maxlength="30"
                autocomplete="new-password"
                required
              />
              <img 
                v-if="showPassword && input.password"
                src="../assets/fonts/feather/eye.svg"
                class="toggle-password"
                @click="togglePassword('newpassword')"
                title="hide password"
                alt="hide password"
              />
              <img 
                v-else-if="!showPassword && input.password"
                src="../assets/images/icons/eye-closed.svg"
                class="toggle-password"
                @click="togglePassword('newpassword')"
                title="show password"
                alt="show password"
              />
            </div>
          </div>

          <!-- Update Password Button -->
          <button type="submit" class="btn btn-auth-primary">
            Update Password
          </button>
        </form>

        <!-- Divider -->
        <hr class="form-divider" />

        <!-- Links -->
        <div class="links-container">
          <router-link to="/auth/login" class="auth-link">
            Already have an account?
          </router-link>
          <router-link to="/auth/register" class="auth-link register-link">
            Create your free account – Register now!
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserController from "../../services/userController";
import Userauth from "../auth/js/index";
export default {
  name: "forgotpassword",
  data() {
    return {
      showPassword:false,
      input: { email: "", password: "", token: "" },
      auth: "",
      change_password: false,
    };
  },
  mounted() {
    if (this.$route.query.tkn) {
      this.change_password = true;
      this.input.token = this.$route.query.tkn;
    }
  },
  methods: {
    async sendMail() {
      let payload = { email: this.input.email };
      let response = await UserController.sendForgotPasswordMail(payload);
      if (response.result) {
        this.$toasted.show(
          "please check your mail and update your password from click on reset link",
          {
            theme: "outline",
            position: "bottom-center",
            type: "success",
            duration: 5000,
          }
        );
      } else {
        this.$toasted.show(response.message, {
          theme: "outline",
          position: "bottom-center",
          type: "error",
          duration: 3000,
        });
      }
    },
    async changePassword() {
      if (this.validate()) {
        var payload = {
          password: this.input.password,
          token: this.input.token,
        };
        let response = await UserController.changePassword(payload);
        if (response.result) {
          this.$toasted.show("Successfully Password changed", {
            theme: "outline",
            position: "bottom-center",
            type: "success",
            duration: 3000,
          });
          this.$router.replace("/auth/login");
        } else {
          this.$toasted.show(response.message, {
            theme: "outline",
            position: "bottom-center",
            type: "error",
            duration: 3000,
          });
        }
      }
      console.log(response);
    },
    async Auth() {
      let response = await UserController.authenticate();
      if (response != true) {
        clearInterval(this.auth);
        Userauth.Logout();
      }
    },
    validate() {
      if (this.input.password == "" ){
        this.$toasted.show("Please enter password", {
          theme: "outline",
          position: "bottom-center",
          type: "error",
          duration: 2000,
        });
        return false;
      } else if (/\s/.test(this.input.password)) {
        this.$toasted.show("Password should not contain spaces", {
          theme: 'outline',
          position: "bottom-center",
          type: 'error',
          duration: 2000
        });
        return false;
      }else if (this.input.password.length < 6) {
        this.$toasted.show("password length should be more then 6 character", {
          theme: "outline",
          position: "bottom-center",
          type: "error",
          duration: 2000,
        });
        return false;
      }
      return true;
    },
    togglePassword(id){
          const password = document.getElementById(id);
          this.showPassword = this.showPassword === false ? true: false
          const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
          password.setAttribute('type', type);
        }
  },
};
</script>

<style>
@import '../assets/css/auth.css';
</style>

<style scoped>
/* Forget password page specific styles */
.register-link {
  color: #3477F4;
}
</style>